import RoomAllocationsControl from '../RoomAllocationsControl/RoomAllocationsControl'

class BookingFilter {
    constructor(el) {
        this.form = el.querySelector('[data-booking-form]')
        this.load = el.querySelector('[data-booking-load]')
        this.reset = el.querySelector('[data-booking-reset]')
        this.options = [...el.querySelectorAll('[data-booking-date]')]
        this.currentFilter = null
        this.entriesPerPage = 5
        this.limit = 3
        this.roomAllocation = el.querySelector('[data-room-allocation]')


        if (this.form === null || this.options.length === 0) {
            // Error, missing DOM elements
            return
        }


        this.init()

    }


    init() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault()
            const formData = new FormData(this.form)
            const formDataObject = {}

            for (const [name, value] of formData.entries()) {
                if (value) {
                    formDataObject[name] = value
                }
            }

            //this.currentFilter = Object.keys(formDataObject).length === 0 ? null : JSON.stringify(formDataObject)
            this.currentFilter = Object.keys(formDataObject).length === 0 ? null : formDataObject


            this.updateOptions()
        })

        this.form.addEventListener('reset', (e) => {
            this.resetFilter()

        })

        if (this.load) {
            this.load.addEventListener('click', (e) => {
                this.limit += this.entriesPerPage
                this.updateOptions()
            })
        }

        if (this.reset) {
            this.reset.addEventListener('click', (e) => {
                e.preventDefault()
                this.form.reset()
            })
        }


        if (this.roomAllocation) {
            this.RoomAllocationsControl = new RoomAllocationsControl(this.roomAllocation, this.form)

            this.RoomAllocationsControl.setChangeListener((change) => {

                const newGuestParam = this.RoomAllocationsControl.getGuestParam()
                this.options.map(option => {
                    const href = option?.firstElementChild?.href
                    if (href) {
                        const Url = new URL(href)
                        Url.searchParams.set('guests', newGuestParam)
                        option.firstElementChild.href = Url.href
                    }

                })

            })

        }

    }

    resetFilter() {
        this.currentFilter = null
        this.limit = this.entriesPerPage
        this.updateOptions()
    }


    updateOptions() {
        this.options.map((e, index0) => {
            // for now, only check the date
            const hidden = this.currentFilter ? e.dataset.bookingDate !== this.currentFilter.date : false

            e.toggleAttribute('data-hidden', hidden)
            e.classList.remove('display-none')

            if (this.currentFilter == null) {
                const hideOptions = index0 >= this.limit
                e.classList.toggle('display-none', hideOptions)
            }

        })


        //this.load.classList.toggle('display-none', this.options.length <= this.limit)
        this.load.classList.toggle('display-none', this.options.length <= this.limit || this.currentFilter)

    }


}

export default BookingFilter


